import { Box, Chip, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';

import { InProgressAnnotationCard } from './InProgressAnnotationCard';
import { useAppDispatch } from '../../../../lib/store';
import { clearCreateAnnotationError } from '../../state/annotationSlice';

interface NewAnnotationCardProps {
  annotationNumber: number;
  conceptId: string;
  cardId?: string;
  removeNewAnnotationCardId?: (tempId: string) => void;
}

export const NewAnnotationCard = ({
  annotationNumber,
  conceptId,
  cardId = '',
  removeNewAnnotationCardId,
}: NewAnnotationCardProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const removeAnnotationCard = () => {
    if (removeNewAnnotationCardId) {
      removeNewAnnotationCardId(cardId);
    }

    dispatch(clearCreateAnnotationError());
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
        border: `1px solid ${theme.palette.divider}`,
        p: theme.spacing(4),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: '500' }}>
            Annotation #{annotationNumber}
          </Typography>
          <Chip
            variant="filled"
            sx={{
              backgroundColor: theme.palette.grey[200],
              size: 'small',
              fontSize: '13px',
            }}
            label={formatMessage({ id: 'workspaceCommon.annotationConfig.conceptCard.inProgress' })}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <IconButton onClick={() => removeAnnotationCard()}>
            <Icon
              icon={`delete${cardId ? '' : 'Disabled'}`}
              id="delete-annotation-icon"
              width={20}
              height={20}
            />
          </IconButton>
        </Box>
      </Box>
      <InProgressAnnotationCard
        annotation={null}
        conceptId={conceptId}
        editingAnnotationId={cardId || undefined}
        onCancelNew={cardId ? removeAnnotationCard : undefined}
      />
    </Box>
  );
};
